import React, { useState, useCallback, useEffect } from "react";
import api from "~/api/api";
import Select from "react-select";
import debounce from "lodash.debounce";
import get from 'lodash/get';

function ReactSingleSelectServer({
                                     placeholder = "Select...",
                                     onChange,
                                     value = null,
                                     disabled = false,
                                     errors,
                                     name,
                                     fetchUrl,
                                 }) {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const errorMessage = get(errors, `${name}.message`);
    const handleChange = (option) => {
        if (onChange) {
            onChange(option);
        }
    };

    const fetchOptions = async (inputValue = "") => {
        if (!fetchUrl) {
            setOptions([]);
            return;
        }
        setLoading(true);
        api.get(fetchUrl, {
            params: { searchString: inputValue },
        })
            .then((res) => {
                const formatted = res.data.map((item) => ({
                    label: item.Name || item.Label || "N/A",
                    value: item.Id || item.Value,
                    image: item.ImageUrl || item.Avatar || null, // 🔹 thêm ảnh nếu có
                }));
                setOptions(formatted);
            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => {
                setLoading(false);
            })
    };

    useEffect(() => {
        fetchOptions("");
    }, [fetchUrl]);

    const debouncedFetch = useCallback(debounce(fetchOptions, 400), []);

    return (
        <div className="react-select-container">
            <Select
                value={value}
                onChange={handleChange}
                options={options}
                placeholder={placeholder}
                classNamePrefix="react-select"
                isDisabled={disabled}
                isLoading={loading}
                isSearchable={true}
                onInputChange={(inputValue, actionMeta) => {
                    if (actionMeta.action === "input-change") {
                        debouncedFetch(inputValue);
                    }
                    return inputValue;
                }}
                noOptionsMessage={() =>
                    loading ? "Searching..." : "No results found"
                }
                formatOptionLabel={(option) => (
                    <div className="d-flex align-items-center gap-2">
                        {option.image && (
                            <img
                                src={option.image}
                                alt=""
                                width={24}
                                height={24}
                                style={{ borderRadius: "50%", objectFit: "cover" }}
                            />
                        )}
                        <span>{option.label}</span>
                    </div>
                )}
            />

            {errorMessage && (
                <span className="fs-9 fw-bold text-danger">{errorMessage}</span>
            )}
        </div>
    );
}

export default ReactSingleSelectServer;
